module.exports = __webpack_public_path__ + "img/portrait.c34e3394.jpg";